module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "miniprogram-box common-style"
  }, [_c('div', {
    staticClass: "miniprogram-box__header common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content1 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content2 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content3 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content4 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content5 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content6 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content7 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content8 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content9 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content10 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content11 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniprogram-box__content12 common-style"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('c-button', {
    staticClass: "footer__btn",
    nativeOn: {
      "click": function($event) {
        _vm.downLoadApp()
      }
    }
  }, [_vm._v("\n        立即开通\n      ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba549464","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/miniprogram/index.vue
// module id = 388
// module chunks = 0